import * as React from 'react';
import { cn } from '../';

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  // Chroma specific classes
  const CHROMA_CLASSES =
    'h-12.5 shadow-none py-2 px-4 bg-background border-border focus-visible:border-border-active focus-visible:outline-none focus-visible:ring-0 selection:bg-background-inverse selection:text-foreground-inverse';

  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground border-input flex h-18 w-full min-w-0 rounded-md border bg-transparent px-6 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-14 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
        CHROMA_CLASSES,
        className
      )}
      {...props}
    />
  );
}

export { Input };
